module.exports = __webpack_public_path__ + "img/defaultCoinIco.50d7e823.png";